import classNames from 'classnames';

import styles from './index.module.scss';

type Props = {
  readonly label: string;
  readonly isActive: boolean;
  readonly isDanger: boolean;
  readonly isFocused: boolean;
};

/**
 * NotchedBorder Component
 *
 * Lumenia 托管认证界面：标签已移到字段上方（见 InputField），这里只剩两件事——
 * 画输入框的 1px 描边，以及聚焦时的石青焦点环。
 *
 * 上游用 fieldset + legend 是为了让标签能压在边框缺口上做「浮动标签」；标签外移后
 * 缺口没有用了，legend 一并去掉，两个 fieldset 退化成纯粹的描边层与外环层。
 * Props 与调用方一字未动（label 仍用于 noLabel 分支的内边距差异）。
 */
const NotchedBorder = ({ label, isActive, isDanger, isFocused }: Props) => {
  return (
    <div
      className={classNames(
        styles.container,
        isDanger && styles.danger,
        isActive && styles.active,
        isFocused && styles.focused,
        !label && styles.noLabel
      )}
    >
      <fieldset className={styles.border} />
      <fieldset className={styles.outline} />
    </div>
  );
};

export default NotchedBorder;
